import PropTypes from 'prop-types';
import { PopUp } from 'uikit/PopUp/PopUp';
import './ConfirmationModal.scss';

/**
 * Shared shell for every 2FA / verification-code modal in the app (TRN-7254). Provides the card
 * itself (480px, 24px radius, drop shadow) via uikit/PopUp — header, body, and footer content are
 * entirely up to the consumer, since the two Figma frames this was built from (the code-entry
 * modal and the switch-method modal) have different header shapes (title+subtitle+close-X vs. a
 * plain centered title with no close icon).
 *
 * @param { boolean } show
 * @param { function } onClose
 * @param { ('neutral'|'glow') } shadow - 'neutral' (default) matches the code-entry modal's
 *   grey shadow; 'glow' matches the switch-method modal's violet-tinted one. Same 24px radius/480
 *   width either way.
 */
export const ConfirmationModal = ({ show, onClose, shadow = 'neutral', className, children }) => (
  <PopUp
    show={show}
    onClose={onClose}
    className={`confirmation-modal confirmation-modal--shadow-${shadow} ${className || ''}`}
  >
    {children}
  </PopUp>
);

ConfirmationModal.propTypes = {
  show: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onClose: PropTypes.func,
  shadow: PropTypes.oneOf(['neutral', 'glow']),
  className: PropTypes.string,
  children: PropTypes.node
};
